import React, { PureComponent } from "react";
import { DatePicker } from "antd";
import moment from "moment";

export default class DateInputWithHourAndMinute extends PureComponent {
  state = {
    value: null,
  };

  static getDerivedStateFromProps(props) {
    console.log('itemInfoitemInfoitemInfoitemInfo', props);
    return {
      value: props.value ? moment(props.value) : null,
    };
  }

  _changeHandle = (date) => {
    const { onChange } = this.props;
    onChange && onChange(date ? date.format("YYYY-MM-DD HH:mm") : null);
  };

  render() {
    const { value } = this.state;
    return (
      <DatePicker
        format={"DD/MM/YYYY HH:mm"}
        style={{ width: "100%" }}
        showTime={true}
        {...this.props}
        value={value}
        onChange={this._changeHandle}
        placeholder="Chọn ngày"
      />
    );
  }
}
